const pluralization = (choice, choicesLength) => {
    const TEEN_MIN = 10;
    const TEEN_MAX = 20;
    const CHOICES_LENGTH_MAX = 4;
    const PLURALIZATION_RESULT = {
        first: 1,
        second: 2,
        third: 3,
    };

    const AGE_REMAINDER = {
        two: 2,
        four: 4,
    };

    if (choice === 0) {
        return 0;
    }

    const teen = choice > TEEN_MIN && choice < TEEN_MAX;
    const endsWithOne = choice % TEEN_MIN === 1;

    if (choicesLength < CHOICES_LENGTH_MAX) {
        return (!teen && endsWithOne) ? PLURALIZATION_RESULT.first : PLURALIZATION_RESULT.second;
    }

    if (!teen && endsWithOne) {
        return PLURALIZATION_RESULT.first;
    }

    if (!teen && choice % TEEN_MIN >= AGE_REMAINDER.two && choice % TEEN_MIN <= AGE_REMAINDER.four) {
        return PLURALIZATION_RESULT.second;
    }

    return (choicesLength < CHOICES_LENGTH_MAX) ? PLURALIZATION_RESULT.second : PLURALIZATION_RESULT.third;
};

export default pluralization;